export default defineI18nConfig(() => {
    return {
        legacy: false,
        globalInjection: true,
        fallbackLocale: process.env.I18N_DEFAULT_LOCALE ?? 'de',
    };
});
